import React from 'react'
import { ArrowRightIcon } from '../../../conf/images'
import './QuestionCell.css'
interface QuestionCellProps {
    title?: string
    onClick?: (e: React.MouseEvent) => void
}
const QuestionCell: React.FC<QuestionCellProps> = (props) => {
    const { title = '', onClick = () => undefined } = props
    return (
        <div className='question-cell' onClick={onClick}>
            <p className='ellipsis'>{title}</p>
            <img src={ArrowRightIcon} alt='>' />
        </div>
    )
}

export default QuestionCell
